import { render } from "./SummaryCard.vue?vue&type=template&id=3787f684&scoped=true&ts=true"
import script from "./SummaryCard.vue?vue&type=script&lang=ts"
export * from "./SummaryCard.vue?vue&type=script&lang=ts"

import "./SummaryCard.vue?vue&type=style&index=0&id=3787f684&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3787f684"]])

export default __exports__